import validator from 'validator'

export const isValidDate = (value) => {
  try {
    const arr = value.split('/')
    const dateStr = `${arr[2]}/${arr[1]}/${arr[0]}`
    return validator.isDate(dateStr)
  } catch (err) {
    return false
  }
}

export const isValidNumber = (value) => {
  try {
    return validator.isNumeric(`${value}`)
  } catch (err) {
    return false
  }
}

export const validateColumn = (value, { columnName, required, rowsSize, validator, errorMessage, $t }) => {
  const isChoseColumn = rowsSize > 0
  if (!isChoseColumn) {
    return null
  }

  const isEmpty = value == null
  if (isEmpty && required) {
    return $t('message.thiscolumnisrequired', { name: columnName })
  }

  const isError = validator && !validator(value)
  if (!isEmpty && isError) {
    return errorMessage
  }

  return null
}



// WEBPACK FOOTER //
// ./src/helpers/validate.js